import { z } from "zod";

export const CHAT_MAX_CHARS = 2000;
export const CHAT_PHOTO_MAX_MB = 15;
export const CHAT_PHOTO_TYPES: Record<string, string> = {
  "image/jpeg": "image/jpeg",
  "image/png": "image/png",
  "image/webp": "image/webp",
  "image/heic": "image/heic",
};

export const chatMessageSchema = z.object({
  body: z.string().max(CHAT_MAX_CHARS, `Eine Nachricht kann höchstens ${CHAT_MAX_CHARS} Zeichen lang sein.`).default(""),
});

export const chatSaveSchema = z.object({ folderId: z.uuid() });

export interface ChatMessageInfo {
  id: string;
  body: string;
  hasPhoto: boolean;
  createdAt: string;
  createdBy: string | null;
  mine: boolean;
  canDelete: boolean;
}

export interface TodayInfo {
  unreadChats: { projectId: string; projectName: string; count: number; lastAt: string }[];
  events: { id: string; title: string; startsAt: string; endsAt: string; allDay: boolean; projectId: string | null; projectName: string | null }[];
  newFiles: { id: string; name: string; kind: string; projectId: string; projectName: string; createdAt: string; createdBy: string | null }[];
}
